import GoogleMapTypeEnum from '../../types/googleMapTypes';

const mapStyleSheetPathMap: Record<GoogleMapTypeEnum, string> = {
  [GoogleMapTypeEnum.SZUKAJ]: 'szukaj',
  [GoogleMapTypeEnum.BIURA]: 'biura',
  [GoogleMapTypeEnum['BIURO-SZCZEGOLY']]: 'biuro-szczegoly',
};

const getStylesheetPath = (type: GoogleMapTypeEnum): string | null => {
  const mapValue = mapStyleSheetPathMap[type];

  return mapValue ? `./stylesheets/${mapValue}.scss` : null;
};

export default getStylesheetPath;
